import { useEffect } from 'react';

const bodyCN = 'modal-open';

const useBodyModalOpen = isModalOpen => {
  useEffect(() => {
    const element = document.getElementsByTagName('body')[0];

    if (isModalOpen) {
      element.classList.add(bodyCN);
    } else {
      element.classList.remove(bodyCN);
    }
    return () => {
      element.classList.remove(bodyCN);
    };
  }, [isModalOpen]);

  return {};
};

export default useBodyModalOpen;
